module.exports = __webpack_public_path__ + "static/west-1f35743708669b11cdfe632690c25ad5.jpg";